// PageVariablesSegurados.js

export const pageVariables = {
    headers: [
       'AGENDAMENTO', 'SEGURADO', 'DATA VISITA', 'STATUS', 'COMETARIO'
    ],
    headerInfo: {
        title: "Ficha de Visita",
        description: "Esta seção fornece informações detalhadas sobre as fichas de visita, incluindo dados como consultor, data da visita e status atual. Acompanhe os detalhes de cada visita para garantir um acompanhamento preciso dos segurados."
    },
    inputs: [
        {
            name: "rg",
            type: "text",
            label: "Status"
        },
        {
            name: "email",
            type: "text",
            label: "Comentario"
        },
    ]
    ,
    page: process.env.VUE_APP_API_URL+"fichas-visita",
    pageStoreLocation: process.env.VUE_APP_API_URL+"location",
    pagePauseLocation: process.env.VUE_APP_API_URL+"location/pausa",
    pageCheckInLocation: process.env.VUE_APP_API_URL+"location/check-in",
    pageStoreProposta: process.env.VUE_APP_API_URL+"segurado-data-for-form/",
    updateStatus: process.env.VUE_APP_API_URL+"fichas-visita-status/",
    pageStorePropostaCreate: process.env.VUE_APP_API_URL+"propostas",
    seachFilterKey: "nome"
};
